// extracted by mini-css-extract-plugin
export var header = "fp-9v";
export var header__placeholder = "fp-bw";
export var header__promoBannerPlaceholder = "fp-aw";
export var mt0 = "fp-2v";
export var mt1 = "fp-3v";
export var mt2 = "fp-4v";
export var mt3 = "fp-5v";
export var mt4 = "fp-6v";
export var mt5 = "fp-7v";
export var mt6 = "fp-8v";